<template>
  <div>
    <b-list-group>
      <b-list-group-item v-for="obj in page_objs">
        <LedgerObjSummary v-bind:obj="obj" />
      </b-list-group-item>
    </b-list-group>

    <MarkerPaginator v-on:prev="prev" v-on:next="next"
                     v-bind:markers="markers" v-bind:page="page" />
  </div>
</template>

<script>
import LedgerObjSummary from '../LedgerObjSummary'
import MarkerPaginator from '../MarkerPaginator'

export default {
  name: 'AccountDetailsLedgerObjs',

  components : {
    LedgerObjSummary,
    MarkerPaginator
  },

  props : {
    id : String,
    objs : Array,
    markers : Array
  },

  data : function(){
    return {page : 0};
  },

  computed : {
    page_objs : function(){
      return this.objs[this.page];
    },
  },

  watch : {
    id : function(){
      this.page = 0;
      this.$emit('sync', this.page);
    }
  },

  methods : {
    prev : function(){
      this.page -= 1;
      this.$emit('sync', this.page);
    },

    next : function(){
      this.page += 1;
      this.$emit('sync', this.page);
    },
  }
}
</script>

